import React from 'react';
import { Book } from '../../types/book.types';
import { Transaction } from '../../types/transaction.types';
import { SaleReturnViewType } from '../../types/view.types';
import './RightColNumpad.css';

import { ErrorPopup } from './components/ErrorPopup';
import { SearchHeader } from './components/SearchHeader';
import { SearchResults } from './components/SearchResults';
import { InvoiceSearchResults } from './components/InvoiceSearchResults';
import { NumpadGrid } from './components/NumpadGrid';
import { ActionButtons } from './components/ActionButtons';

export interface RightColNumpadProps {
  isHidden: boolean;
  errorMessage: string | null;
  setErrorMessage: (v: string | null) => void;
  view: SaleReturnViewType;
  numpadValue: string;
  setNumpadValue: (v: string) => void;
  searchQuery: string;
  setSearchQuery: (v: string) => void;
  isSearchFocused: boolean;
  setIsSearchFocused: (v: boolean) => void;
  detailedBookId: string | null;
  setDetailedBookId: (v: string | null) => void;
  filteredBooksForSearch: Book[];
  isSearchLoading: boolean;
  searchError: string | null;
  /** Resultado del buscador de facturas (solo en devoluciones). */
  invoiceResult: Transaction | null;
  isInvoiceSearchLoading: boolean;
  invoiceSearchError: string | null;
  onSelectInvoice: (invoice: Transaction) => void;
  addToCart: (book: Book, source?: any) => void;
  selectedSearchSource: any | null;
  setSelectedSearchSource: (v: any | null) => void;
  onNumpadPress: (key: string) => void;
  currentReturnTxId: string | null;
  handleProcessReturn: (txId: string, cart: any[], flag: boolean) => void;
  returnCart: any[];
  handleScan: (val: string) => void;
  simulateRandomScan: () => void;
  handleManualEntry: (val: string) => void;
  isScanning: boolean;
}

export const RightColNumpad: React.FC<RightColNumpadProps> = (props) => {
  return (
    <aside className={`right-col-aside ${props.isHidden ? 'right-col-hidden' : ''}`}>
      <ErrorPopup errorMessage={props.errorMessage} onClose={() => props.setErrorMessage(null)} />

      <SearchHeader
        view={props.view}
        numpadValue={props.numpadValue}
        searchQuery={props.searchQuery}
        setSearchQuery={props.setSearchQuery}
        isSearchFocused={props.isSearchFocused}
        setIsSearchFocused={props.setIsSearchFocused}
        setDetailedBookId={props.setDetailedBookId}
      />

      <div className="results-container">
        {props.isSearchFocused ? (
          // En devoluciones el input busca facturas por id, no en el catalogo.
          props.view === 'returns' ? (
            <InvoiceSearchResults
              searchQuery={props.searchQuery}
              invoice={props.invoiceResult}
              isLoading={props.isInvoiceSearchLoading}
              error={props.invoiceSearchError}
              onSelectInvoice={props.onSelectInvoice}
            />
          ) : (
            <SearchResults
              searchQuery={props.searchQuery}
              filteredBooksForSearch={props.filteredBooksForSearch}
              isLoading={props.isSearchLoading}
              error={props.searchError}
              detailedBookId={props.detailedBookId}
              setDetailedBookId={props.setDetailedBookId}
              selectedSearchSource={props.selectedSearchSource}
              setSelectedSearchSource={props.setSelectedSearchSource}
              addToCart={props.addToCart}
              setSearchQuery={props.setSearchQuery}
              setNumpadValue={props.setNumpadValue}
              setIsSearchFocused={props.setIsSearchFocused}
            />
          )
        ) : (
          <NumpadGrid onNumpadPress={props.onNumpadPress} />
        )}
      </div>

      <ActionButtons
        view={props.view}
        currentReturnTxId={props.currentReturnTxId}
        returnCart={props.returnCart}
        handleProcessReturn={props.handleProcessReturn}
        numpadValue={props.numpadValue}
        handleScan={props.handleScan}
        simulateRandomScan={props.simulateRandomScan}
        filteredBooksForSearch={props.filteredBooksForSearch}
        detailedBookId={props.detailedBookId}
        selectedSearchSource={props.selectedSearchSource}
        addToCart={props.addToCart}
        setSearchQuery={props.setSearchQuery}
        setNumpadValue={props.setNumpadValue}
        setIsSearchFocused={props.setIsSearchFocused}
        setDetailedBookId={props.setDetailedBookId}
        setSelectedSearchSource={props.setSelectedSearchSource}
        handleManualEntry={props.handleManualEntry}
        isScanning={props.isScanning}
      />
    </aside>
  );
};
